import React from 'react'

export default function Spacer(props) {
  return <div {...props} style={{marginTop: props.amount || "20px"}} />
}